export async function loadCSS(href, media, el = document.querySelector('head')) {
  if (!el) throw new Error('No element to load CSS into');
  return new Promise((resolve, reject) => {
    if (!el?.querySelector(`link[href="${href}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      if (media) link.media = media;
      link.onload = resolve;
      link.onerror = reject;
      el.append(link);
    } else {
      resolve();
    }
  });
}

export async function loadScript(src, attrs = {}, el = document.querySelector('head')) {
  return new Promise((resolve, reject) => {
    if (!el.querySelector(`script[src="${src}"]`)) {
      const script = document.createElement('script');
      script.src = src;
      if (attrs) {
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const attr in attrs) {
          script.setAttribute(attr, attrs[attr]);
        }
      }
      script.onload = resolve;
      script.onerror = reject;
      el.append(script);
    } else {
      resolve();
    }
  });
}
